import 'idempotent-babel-polyfill';
import 'intersection-observer';
import 'core-js';
import 'custom-event-polyfill';
import $ from 'jquery';
import './utils/jquery-events';
import _ from 'underscore';
import LazyLoad from './app/boot/lazy-load';
import InitData from './app/data/init-data';
import loadModules from './app/pages/load-modules';
import { loadModule, handleError } from 'utils/code-split';
import { MainNavigation } from 'containers';

MainNavigation();

import 'core/style/master';
import 'core/style/_include-components';

window._ = window._ || _;
window.$ = window.$ || $;
const initData = InitData.currentOrSet();
LazyLoad();

if (initData) {
    loadModules(initData)
        .then(module => loadModule(module, initData))
        .catch(err => handleError(err));
}



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app.js